import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../profile_edit';

Launcher.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default function Launcher(props) {
  return (
    <Dialog onCancel={props.onClose} />
  );
}
